import { render, staticRenderFns } from "./HeaderTitle.vue?vue&type=template&id=0c8dbd20&scoped=true&"
import script from "./HeaderTitle.vue?vue&type=script&lang=js&"
export * from "./HeaderTitle.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTitle.vue?vue&type=style&index=0&id=0c8dbd20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8dbd20",
  null
  
)

export default component.exports